<!--
 * @Description:
 * @Author: luoshoufeng@szkingdom.com
 * @Date: 2024-04-19 10:30:38
 * @LastEditors: luoshoufeng@szkingdom.com
-->
<!--
Author: Liubo
Date: 2018-09-17
Desc: 业务组件标题栏
 -->
<template>
    <div v-if="backUrlName" class="comp-bizcomp-dc-title comp">
        <div class="back-content" v-on:click="handleBack">
            <i class="el-icon-arrow-left" ria-hidden="true"></i>
            <span class="back-text">返回</span>
        </div>
        <div class="slot">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    name: "BizcompTitle",
    props: {
        backUrlName: {
            type: String,
            default: ""
        },
        backUrlQuery: {
            type: Object,
            default: () => {
                return {};
            }
        }
    },
    data() {
        return {};
    },
    methods: {
        handleBack() {
            this.$router.push({
                name: this.backUrlName,
                query: this.backUrlQuery
            });
        }
    }
};
</script>
<style lang="scss">
.comp-bizcomp-dc-title {
    display: flex;
    .back-content {
        cursor: pointer;
        height: 18px;
        line-height: 18px;
        color: var(--color-primary);
        .back-text {
            margin-right: 16px;
        }
    }
    // 面包屑导航
    .el-breadcrumb {
        height: 18px;
        line-height: 18px;
    }
    .el-breadcrumb__separator {
        margin: 0;
    }
    .is-link {
        color: var(--color-primary) !important;
        font-weight: normal !important;
    }
}
</style>
